import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CookieConsentService } from '../../../core/privacy/cookie-consent.service';

@Component({
  selector: 'mkzs-cookie-banner',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.css',
})
export class CookieBannerComponent {
  protected readonly consentService = inject(CookieConsentService);

  protected accept(): void {
    this.consentService.acceptAnalytics();
  }

  protected reject(): void {
    this.consentService.rejectOptionalCookies();
  }
}
